import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Question } from 'src/app/core-module/models/Audits/question';
import { QuestionAnswer } from 'src/app/core-module/models/Audits/question-answer';
import { StandardQuestionEntry } from 'src/app/core-module/models/Audits/standard-question-entry';
import { DDL } from 'src/app/core-module/models/ddl';
import { inOutAnimation } from 'src/app/shared-module/animations/inOutAnimation';

@Component({
    selector: 'app-edit-question-selections',
    templateUrl: './edit-question-selections.component.html',
    styleUrls: ['./edit-question-selections.component.scss'],
    animations: [inOutAnimation],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditQuestionSelectionsComponent {

  public question: Question = new Question();

  @Input() set Question(value: Question) {
    this.question = value;
    this.initialQuestionTypeID = value.QuestionType.ID;
    this.initialRequirementSetting = value.Required;
    this.setPageMode();
    this.setDefaultState();
    this.setMaxScoreState();
  }; get Question() {
    return this.question;
  };
  @Input() public answerTypes: DDL[];
  @Input() public groupEditOn: boolean = false;
  @Input() public newAudit: boolean = false;
  @Output() public questionChange: EventEmitter<Question> = new EventEmitter<Question>();
  @Output() public deleteQuestion: EventEmitter<Question> = new EventEmitter<Question>();
  @Output() public duplicateQuestion: EventEmitter<Question> = new EventEmitter<Question>();
  @Output() public updateEditMode: EventEmitter<Question> = new EventEmitter<Question>();

  public showAnswers: boolean = false;
  public showOptions: boolean = false;
  public showActions: boolean = false;

  //page warnings
  private initialQuestionTypeID = -1;
  public typeWarning: boolean = false;
  private initialRequirementSetting = false;
  public requiredWarning: boolean = false;



  public editMode: boolean = false;
  public showCoreInfo: boolean = true;
  public showSettings: boolean = false;
  public showScoring: boolean = false;
  public showAdvancedScore: boolean = false;

  public complianceScoringIssue: boolean = false;

  public currentQuestionAnswer: QuestionAnswer = new QuestionAnswer();

  public isBasic: boolean = false;
  public isHeader: boolean = false;
  public isSelections: boolean = false;

  public deleteMode: boolean = false;
  public defaulOptionSelcted: boolean = false;

  private originalQuestion: Question = new Question();





  setPageMode() {
    if (!this.newAudit && this.question.QuestionID != -1) {
      if (this.initialQuestionTypeID != this.question.QuestionType.ID) {
        this.typeWarning = true;
      } else {
        this.typeWarning = false;
      }
    }
    switch (this.question.QuestionType.ID) {
      case 1:
      case 2:
      case 3:
        this.isBasic = false;
        this.isHeader = false;
        this.isSelections = true;
        break;
      case 4:
      case 5:
      case 8:
      case 9:
      case 10:
      case 11:
        this.isHeader = false;
        this.isSelections = false;
        this.isBasic = true;
        break;
      case 6:
        this.isBasic = false;
        this.isSelections = false;
        this.isHeader = true;
        break;
    }
    if (this.Question.InitialQuestion){
      this.editMode = true;
    }
  }
  setDefaultState() {
    this.question.QuestionAnswers.forEach(q => {
      if (q.IsDefault) {
        this.defaulOptionSelcted = true;
      }
    })
  }
  setMaxScoreState() {
    if (this.question.MaxScore != -1) {
      this.question.AdvancedMaxScore = true;
    }
  }
  toggleEditMode() {
    if (this.deleteMode) {
      return;
    }    
     this.updateEditMode.emit(this.question);
    if(!this.editMode){
     
      this.originalQuestion = new Question(this.question);
    }
    this.editMode = !this.editMode;
    this.question.IsCurrentEdit = this.editMode;
  }

  confirmChanges() {
    this.originalQuestion = new Question(this.question);
    this.editMode = false;
    this.question.InitialQuestion = false;
    this.updateEditMode.emit(this.question);
  }
  undoChanges() {
    //If the question has not been confirmed then remove it
    if(this.question.InitialQuestion){
      this.deleteQuestion.emit(this.question);
    }else{
       this.question = new Question(this.originalQuestion);
    }
   this.updateEditMode.emit(this.question);
    this.editMode = false;
  }
  isMaxScore(score: number) {
    var maxScore = this.getMaxScore();
    return score == maxScore;

  }
  getMaxScore(): number {
    var maxScore = 0;

    this.question.QuestionAnswers.forEach(e => {
      if (this.question.QuestionType.ID == 3) {
        maxScore += e.ComplianceScore;
      } else {
        if (e.ComplianceScore > maxScore) {
          maxScore = e.ComplianceScore
        }
      }

    })
    return maxScore;
  }
  switchToCoreInfo() {
    this.displayReset();
    this.showCoreInfo = true;
  }
  switchToSettings() {
    this.displayReset();
    this.showSettings = true;
  }
  switchToScoring() {
    this.displayReset();
    this.showScoring = true;
  }
  displayReset() {
    this.showCoreInfo = false;
    this.showSettings = false;
    this.showScoring = false;
  }
  toggleAdvancedScore() {
    this.question.AdvancedMaxScore = !this.question.AdvancedMaxScore;
    this.questionChanged();
  }

  validateComplianceScore() {
    switch (this.question.QuestionType.ID) {
      case 1: case 2:
        this.complianceScoringIssue = this.calculateSingleScoreFail()
        break;
      case 3:
        this.complianceScoringIssue = this.calculateMultiScoreFail();
        break;

    }

  }
  calculateSingleScoreFail(): boolean {
    var returnAnswer: boolean = true;
    this.question.QuestionAnswers.forEach(e => {
      if (e.ComplianceScore > this.question.ComplianceLimit) {
        returnAnswer = false;
      }
    })
    return returnAnswer;
  }
  calculateMultiScoreFail(): boolean {
    var total: number = 0;
    this.question.QuestionAnswers.forEach(e => {
      total += e.ComplianceScore
    });
    if (total > this.question.ComplianceLimit) {
      return false;
    } else {
      return true;
    }

  }
  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.question.QuestionAnswers, event.previousIndex, event.currentIndex);
    this.sequenceAnswers();
    this.questionChanged();
  }
  sequenceAnswers() {
    var seq = 1;
    this.question.QuestionAnswers.forEach(e => {
      e.Seq = seq;
      seq++;
    });
  }


  compareQuestionTypes(t1: DDL, t2: DDL) {
    if (t1 == null || t2 == null) {
      return false;
    } else {
      return t1.ID == t2.ID;
    }

  }



  changeDefaultAnswer(a: QuestionAnswer) {
    this.questionChanged();
    var selected: boolean = false;
    if (a.IsDefault == false) {
      this.defaulOptionSelcted = false;
      return;
    } else {
      this.defaulOptionSelcted = true;
      return;
    }
  }

  currentDefaultAnswer(): QuestionAnswer | null {
    return this.question.QuestionAnswers.find(answer => answer.Active && answer.IsDefault) ?? null;
  }

  changeDefaultSelection(answer: QuestionAnswer | null) {
    this.question.QuestionAnswers.forEach(questionAnswer => {
      questionAnswer.IsDefault = false;
    });
    if (answer != null) {
      answer.IsDefault = true;
    }
    this.defaulOptionSelcted = answer != null;
    this.questionChanged();
  }



  questionChanged() {
    this.questionChange.emit(this.question);
  }

  addAnswer() {
    this.question.QuestionAnswers.push(new QuestionAnswer({ QuestionAnswerID: -1, AnswerText: 'New Answer', ComplianceScore: 0, QuestionID: -1, IsDefault: false, Actionable: false, Seq: -1 }));
    this.sequenceAnswers();
    this.questionChanged();
  }
  removeAnswer(answer: QuestionAnswer) {
    answer.Active = false;
    this.questionChanged();
  }

  addAction() {
    this.question.StandardActions.push(new StandardQuestionEntry({ StandardQuestionEntryID: -1, StandardEntryText: 'New Standard Action' }));
    this.questionChanged();
  }

  removeAction(action: StandardQuestionEntry) {
    action.Active = false;
    this.questionChanged();
  }

  toggleShowAnswers() {
    this.showAnswers = !this.showAnswers;
  }

  toggleShowOptions() {
    this.question.showEditOptions = !this.question.showEditOptions;
    this.questionChange.emit(this.question);
  }

  toggleShowActions() {
    this.showActions = !this.showActions;
  }
  dupQuestion() {
    if (this.deleteMode) {
      return;
    }
    this.questionChanged();
    this.duplicateQuestion.emit(this.question);
  }
  toggleDelete() {
    this.deleteMode = !this.deleteMode;
  }
  delQuestion() {
    this.deleteQuestion.emit(this.question);
  }
  requiredQuestionChange() {
    if (!this.newAudit) {
      if (this.initialRequirementSetting != this.question.Required && this.question.Required) {
        this.requiredWarning = true;
      } else {
        this.requiredWarning = false;
      }
    }
    this.questionChanged()

  }
}
